import { Container, Typography, Box } from '@mui/material';

/**
 * OCI AI 테스트 - 모델 정보 페이지
 * 
 * @description 사용 가능한 AI 모델 목록 및 상세 정보 페이지
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-20
 */
const OciAiTestModelsPage = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Box mb={3}>
        <Typography variant="h4" component="h1" gutterBottom>
          🎯 AI 모델 정보
        </Typography>
        <Typography variant="body1" color="text.secondary">
          사용 가능한 OCI GenAI 모델들의 상세 정보를 확인하세요.
        </Typography>
      </Box>

      <Box 
        sx={{ 
          height: 400,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '2px dashed #ddd',
          borderRadius: 2,
          backgroundColor: '#f9f9f9'
        }}
      >
        <Typography variant="h6" color="text.secondary">
          🚧 모델 정보 페이지 구현 예정
        </Typography>
      </Box>
    </Container>
  );
};

export default OciAiTestModelsPage;